import React from 'react';
import './Cards.css';
import { Calculator, FileText, PoundSterling, Building2, Briefcase, FileQuestion } from 'lucide-react';

function ServiceCard({ title, icon: Icon, description }) {
  return (
    <div className="service-card">
      <div className="service-icon">
        <Icon size={32} className="icon" />
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
}

function Cards() {
  const services = [
    {
      title: "Tax Returns",
      icon: Calculator,
      description: "Professional assistance with personal and business tax returns, ensuring compliance and maximizing deductions"
    },
    {
      title: "VAT",
      icon: PoundSterling,
      description: "Comprehensive VAT services including returns, planning, and compliance for businesses"
    },
    {
      title: "PAYE",
      icon: FileText,
      description: "Complete payroll and PAYE management services for employers"
    },
    {
      title: "Company Accounts",
      icon: Building2,
      description: "Preparation and filing of company accounts, ensuring accuracy and regulatory compliance"
    },
    {
      title: "Business Support",
      icon: Briefcase,
      description: "General business advisory and management support services"
    },
    {
      title: "Tax Planning",
      icon: FileQuestion,
      description: "Strategic tax planning services including capital gains, inheritance tax, and business planning"
    }
  ];

  return (
    <div className="services-section">
      <div className="services-container">
        <h1>Our Services</h1>
        <p className="services-intro">
          With over 35 years of experience, we provide comprehensive accountancy services to meet all your business needs
        </p>
        <div className="services-grid">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              title={service.title}
              icon={service.icon}
              description={service.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Cards;